class GalleryItem {
    id;
    model_id;
    order;
    type;

    constructor(id, order=null, type) {
        this.order = order;
        this.id = id;
        this.type = type;
    }

}

export class Document extends GalleryItem {
    file;
    name;

    constructor(order=null, file=null, name=null) {
        super(0, order, 'Document');
        this.file = file;
        this.name = name;
    }

    populate = (obj) => {
        this.model_id = obj.modelId || obj.model_id;
        this.order = obj.order;
        this.id = obj.id;
        this.file = obj.file;
        this.name = obj.name;
    }

}

export class Image extends GalleryItem {
    file;

    constructor(order=null, file=null) {
        super(0, order, 'Image');
        this.file = file;
    }

    populate = (obj) => {
        this.model_id = obj.modelId || obj.model_id;
        this.order = obj.order;
        this.id = obj.id;
        this.file = obj.file;
    }
}

export class Link extends GalleryItem {
    link;
    title;

    constructor(order=null, link=null, title=null) {
        super(0, order, 'Link');
        this.link = link;
        this.title = title;
    }

    populate = (obj) => {
        this.model_id = obj.modelId || obj.model_id;
        this.order = obj.order;
        this.id = obj.id;
        this.link = obj.link;
        this.title = obj.title;
    }
    
}
